export const ACCOUNT_MENU_LIST_ID = 'account-menu-list'
